import { API_URL } from 'constants/envs'
import { createBaseQueryWithReauth } from 'store/queries/utils'

export const baseQueryWithReauth = createBaseQueryWithReauth(API_URL)
